/* assets/custom-gbg.js */
(function () {
  if (window.__CUSTOM_GBG_LOADED_V3__) return;
  window.__CUSTOM_GBG_LOADED_V3__ = true;

  /* ----------------- 小工具 / 共用 ----------------- */
  const DBG = false; // 需要除錯可改 true
  const log = (...a) => { if (DBG) console.log('[custom-gbg]', ...a); };

  const QTY_SELECTOR = 'input[name="quantity"], input#Quantity, input.quantity__input';

  function q(sel, ctx = document) { return (ctx || document).querySelector(sel); }
  function qa(sel, ctx = document) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function text(el) { return el ? String(el.textContent || '').trim() : ''; }
  function toInt(v) {
    const n = parseInt(String(v || '').trim(), 10);
    return Number.isFinite(n) ? n : NaN;
  }

  /* ----------------- 尋找區塊/欄位 ----------------- */
  // 找含有「GBG Pattern」標籤的容器（我們要把工具插在它「上方」）
  function findGBGPatternStack() {
    // 先找標題/標籤包含 "GBG Pattern"
    const labelNodes = qa('.po-label, .po-option-label, label, h3, h4, strong, span, div');
    for (const n of labelNodes) {
      const t = text(n);
      if (/^\s*GBG\s*Pattern\b/i.test(t)) {
        return n.closest('.po-stack, .po-option--container, .po-option-container, .field') || n.parentElement || n;
      }
    }
    // 找不到就退而求其次：找文字區塊附近
    const tas = qa('textarea');
    for (const ta of tas) {
      const stack = ta.closest('.po-stack, .po-option--container, .po-option-container, .field');
      const lbl = stack && (stack.querySelector('.po-label, .po-option-label, label, h3, h4, strong, span'));
      if (lbl && /^\s*GBG\s*Pattern\b/i.test(text(lbl))) return stack;
    }
    return null;
  }

  // 取得 GBG Pattern 專屬的 textarea（我們只寫這一個）
  function findGBGPatternTextarea() {
    const stack = findGBGPatternStack();
    if (!stack) return null;
    const ta = stack.querySelector('textarea');
    if (ta) return ta;

    // 若容器內沒有，就以標籤再補抓一次
    const lbl = stack.querySelector('.po-label, .po-option-label, label, h3, h4, strong, span');
    if (lbl && /GBG\s*Pattern/i.test(text(lbl))) {
      // 就近找一個 textarea
      const near = lbl.parentElement || stack;
      const cand = qa('textarea', near);
      if (cand.length) return cand[0];
    }
    return null;
  }

  // 取得 Grid Pattern 的 textarea（作為比對用，不會改寫）
  function findGridPatternTextarea() {
    // 優先找「Grid Pattern」標籤的容器
    const labelNodes = qa('.po-label, .po-option-label, label, h3, h4, strong, span, div');
    for (const n of labelNodes) {
      const t = text(n);
      if (/^\s*Grid\s*Pattern\b/i.test(t)) {
        const stack = n.closest('.po-stack, .po-option--container, .po-option-container, .field') || n.parentElement || n;
        const ta = stack.querySelector('textarea');
        if (ta) return ta;
      }
    }
    // 後備：找全站第一個含有「grid pattern」線索的 textarea
    const hintRe = /grid\s*pattern/i;
    const tas = qa('textarea');
    for (const ta of tas) {
      const hint = `${ta.name || ''} ${ta.id || ''} ${ta.className || ''} ${ta.placeholder || ''}`.toLowerCase();
      if (hintRe.test(hint)) return ta;
    }
    return null;
  }

  // 找 SDL 區塊（讀取 SDL 數量）
  function findSDLStack() {
    const stacks = qa('.po-stack, .po-option--container, .po-option-container, .product-options, .product-form .options, .field');
    for (const st of stacks) {
      const lab = st.querySelector('.po-label, .po-option-label, label, h3, h4, strong');
      if (lab && /\bSDL\b/i.test(text(lab))) return st;
    }
    // 後備：找任何文字含 SDL 的節點
    for (const n of qa('label, span, div, strong, h3, h4')) {
      if (/\bSDL\b/i.test(text(n))) {
        return n.closest('.po-stack, .po-option--container, .po-option-container') || n.closest('div');
      }
    }
    return null;
  }

  // 從「X x SDL」或最近數量控件讀取 SDL 數量
  function qtyFromNxSDL(scope) {
    if (!scope) return 0;
    const nodes = qa('a,span,div,button,small,em,strong,label', scope).concat([scope]);
    for (const el of nodes) {
      const m = (text(el)).match(/(\d+)\s*x\s*sdl/i);
      if (m) return parseInt(m[1], 10) || 0;
    }
    return 0;
  }
  function findNearestQtyEl(scope) {
    try {
      const targets = qa('[role="spinbutton"], input[type="number"], .quantity, .qty');
      if (!targets.length) return q(QTY_SELECTOR) || null;
      const rect = scope && scope.getBoundingClientRect ? scope.getBoundingClientRect() : { top: 0, bottom: 0 };
      let best = { d: Infinity, el: null };
      targets.forEach(el => {
        try {
          const r = el.getBoundingClientRect();
          const d = Math.abs((r.top + r.bottom) / 2 - (rect.top + rect.bottom) / 2);
          if (d < best.d) best = { d, el };
        } catch (e) { }
      });
      return best.el || q(QTY_SELECTOR) || null;
    } catch (e) { return q(QTY_SELECTOR) || null; }
  }
  function qtyFromNearestSpin(stack) {
    const el = findNearestQtyEl(stack);
    if (!el) return 0;
    if (el.matches && el.matches('input')) {
      const v = parseInt(String(el.value || el.getAttribute('aria-valuenow') || '').trim(), 10);
      return Number.isFinite(v) ? v : 0;
    }
    const m = (text(el)).match(/-?\d+/);
    return m ? (parseInt(m[0], 10) || 0) : 0;
  }
  function readSDLQty() {
    const st = findSDLStack();
    if (!st) return 0;
    const n = qtyFromNxSDL(st) || 0;
    if (n > 0) return n;
    const s = qtyFromNearestSpin(st) || 0;
    if (s > 0) return s;
    const globalQty = q(QTY_SELECTOR);
    if (globalQty) {
      const v = parseInt(String(globalQty.value || globalQty.getAttribute('aria-valuenow') || '').trim(), 10);
      return Number.isFinite(v) ? v : 0;
    }
    return 0;
  }

  /* ----------------- UI 建立與驗證邏輯 ----------------- */
  function ensureMsgAbove(target) {
    // 在「GBG Pattern 的 textarea」上方安一條訊息列
    if (!target) return null;
    let wrap = target.__msgWrap;
    if (wrap && wrap.isConnected) return wrap;

    wrap = document.createElement('div');
    wrap.style.cssText = 'margin-bottom:6px;color:#b91c1c;font-size:13px;display:none;';
    wrap.setAttribute('role', 'alert');

    try {
      target.parentElement.insertBefore(wrap, target);
    } catch {
      target.before(wrap);
    }
    target.__msgWrap = wrap;
    return wrap;
  }

  function showMsg(target, msg) {
    const m = ensureMsgAbove(target);
    if (!m) return;
    m.textContent = msg || '';
    m.style.display = msg ? '' : 'none';
  }

  function buildMini(afterStack) {
    if (!afterStack) return null;
    if (document.getElementById('gbg-mini')) return document.getElementById('gbg-mini');

    const mini = document.createElement('div');
    mini.id = 'gbg-mini';
    mini.style.cssText = 'display:inline-block;margin-top:8px;';

    const box = document.createElement('div');
    box.style.cssText = 'display:inline-block;border:1px solid #e6dddd;border-radius:8px;padding:8px;background:transparent;';

    const row = document.createElement('div');
    row.style.cssText = 'display:flex;gap:8px;align-items:center;white-space:nowrap;';

    const w = document.createElement('input');
    w.type = 'text';
    w.placeholder = 'W';
    w.className = 'gbg-w';
    w.style.cssText = 'width:72px;padding:6px;border-radius:6px;border:1px solid #ddd;font-size:13px;';
    const sep = document.createElement('span');
    sep.textContent = '×';
    sep.style.fontWeight = '600';
    const h = document.createElement('input');
    h.type = 'text';
    h.placeholder = 'H';
    h.className = 'gbg-h';
    h.style.cssText = 'width:72px;padding:6px;border-radius:6px;border:1px solid #ddd;font-size:13px;';
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = 'Apply';
    btn.className = 'gbg-apply';
    btn.style.cssText = 'padding:6px 10px;border-radius:6px;border:1px solid #ccc;background:#fff;cursor:pointer;font-size:13px;';

    row.appendChild(w); row.appendChild(sep); row.appendChild(h); row.appendChild(btn);
    box.appendChild(row); mini.appendChild(box);

    // 插在 GBG Pattern 區塊「上方」(或GBG Pattern的標題下方)
    try { afterStack.insertAdjacentElement('afterbegin', mini); }
    catch { (afterStack.parentElement || document.body).appendChild(mini); }

    return mini;
  }

  function mountOnce() {
    const gbgStack = findGBGPatternStack();
    const gbgTA = findGBGPatternTextarea();
    const gridTA = findGridPatternTextarea();
    if (!gbgStack || !gbgTA) { log('GBG stack/textarea not found'); return; }

    let mini = document.getElementById('gbg-mini');
    if (!mini) mini = buildMini(gbgStack);

    // 依 GBG 主要勾選顯示/隱藏
    const anyCheck = (gbgStack.querySelector('input[type="checkbox"], input[type="radio"]'));
    const setVisible = () => {
      const v = anyCheck ? !!anyCheck.checked : true;
      mini.style.display = v ? '' : 'none';
    };
    setVisible();
    if (anyCheck && !anyCheck.__gbgBound) {
      anyCheck.addEventListener('change', setVisible);
      anyCheck.__gbgBound = true;
    }

    const wEl = mini.querySelector('.gbg-w');
    const hEl = mini.querySelector('.gbg-h');
    const btn = mini.querySelector('.gbg-apply');

    const clearMsg = () => showMsg(gbgTA, '');
    wEl.addEventListener('input', clearMsg, { passive: true });
    hEl.addEventListener('input', clearMsg, { passive: true });
    gbgTA.addEventListener('input', clearMsg, { passive: true });

    if (!btn.__wired) {
      btn.addEventListener('click', () => {
        try {
          const W = toInt(wEl.value), H = toInt(hEl.value);
          const hasW = Number.isFinite(W) && W > 0;
          const hasH = Number.isFinite(H) && H > 0;
          if (!hasW || !hasH) { showMsg(gbgTA, 'Please enter W and H.'); return; }

          // 形成統一格式字串（嚴格比對就用這個樣式）
          const pattern = `${W} W x ${H} H`;

          // 先寫入 GBG Pattern
          gbgTA.value = pattern;
          gbgTA.dispatchEvent(new Event('input', { bubbles: true }));
          gbgTA.dispatchEvent(new Event('change', { bubbles: true }));

          // 全部通過
          showMsg(gbgTA, '');
          const prev = btn.textContent; btn.textContent = 'Applied'; setTimeout(() => btn.textContent = prev || 'Apply', 700);
        } catch (e) {
          log('apply err', e);
        }
      });
      btn.__wired = true;
    }
  }

  function scan() {
    try { mountOnce(); } catch (e) { log('scan err', e); }
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);

  try {
    const mo = new MutationObserver(() => setTimeout(scan, 80));
    mo.observe(document.documentElement || document.body, { childList: true, subtree: true });
  } catch (e) { log('observer err', e); }
})();
